import { gql } from "@apollo/client";

import { TWILIO_SUBACCOUNTS_FIELDS } from "./fragments";

export const LIST_TWILIO_SUBACCOUNT = gql`
  ${TWILIO_SUBACCOUNTS_FIELDS}
  query listTwilioSubaccounts {
    listTwilioSubaccounts {
      ...TwilioSubaccountField
    }
  }
`;

export const CREATE_TWILIO_SUBACCOUNT = gql`
  ${TWILIO_SUBACCOUNTS_FIELDS}
  mutation twilioSubaccountCreate(
    $name: String!
    $shareAcrossTenants: Boolean!
  ) {
    twilioSubaccountCreate(
      name: $name
      shareAcrossTenants: $shareAcrossTenants
    ) {
      ...TwilioSubaccountField
    }
  }
`;

export const IMPORT_TWILIO_SUBACCOUNT = gql`
  ${TWILIO_SUBACCOUNTS_FIELDS}
  mutation twilioSubaccountImport(
    $name: String
    $accountSid: String!
    $apiKey: String!
    $apiSecret: String!
    $authToken: String!
    $shareAcrossTenants: Boolean!
  ) {
    twilioSubaccountImport(
      name: $name
      accountSid: $accountSid
      apiKey: $apiKey
      apiSecret: $apiSecret
      authToken: $authToken
      shareAcrossTenants: $shareAcrossTenants
    ) {
      ...TwilioSubaccountField
    }
  }
`;

export const SELECT_TWILIO_SUBACCOUNT = gql`
  mutation twilioSubaccountSelect($twilioSubaccountId: ID) {
    twilioSubaccountSelect(twilioSubaccountId: $twilioSubaccountId) {
      slug
      twilioSubaccount {
        id
        name
        deletedAt
      }
    }
  }
`;

export const SELECT_TWILIO_SUBACCOUNT_FOR_CAMPAIGN = gql`
  mutation twilioSubaccountSelectForCampaign(
    $twilioSubaccountId: ID!
    $campaignId: ID!
  ) {
    twilioSubaccountSelectForCampaign(
      twilioSubaccountId: $twilioSubaccountId
      campaignId: $campaignId
    ) {
      twilioSubaccount {
        id
        name
        deletedAt
      }
    }
  }
`;
